const spacing = {
  xxs: '4px',
  xs: '8px',
  s: '12px',
  m: '16px',
  l: '20px',
  xl:'32px',
  xxl: '40px',
  huge: '60px',
}

const gutter = {
  mobile: spacing.m,
  tablet: spacing.m,
  desktop: spacing.l,
}

export default {
  spacing: {
    ...spacing,
    gutter
  },
  page: {
    maxWidth: {
      desktop: '1000px',
    }
  },
  blog: {
    maxWidth: {
      desktop: '740px'
    }
  }
}


// WEBPACK FOOTER //
// ./src/style/sizes.js